import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

const form = {
  fromDate: new UntypedFormControl(),
  toDate: new UntypedFormControl(),
  bankAccountNumber: new UntypedFormControl(),
  bankCode: new UntypedFormControl(),
  sort: new UntypedFormControl(),
};

@Injectable({
  providedIn: 'root',
})
export class DisbursementSearchForm extends UntypedFormGroup {
  constructor() {
    super(form);
  }
}
